import { featureVoter } from '@fastlessjs/backoffice-layer/dist/services';

export type Policy =
  | 'detail:trace'
  | 'display:createdByEmail'
  | 'display:createdByRole'
  | 'display:selectEnterprise'
  | 'search:order'
  | 'tenant:enterprise'
  | 'traceList:clients'
  | 'traceList:admins'
  | 'organizations:list'
  | 'organizations:create'
  | 'organizations:update'
  | 'organizations:delete'
  | 'organizations:view'
  | 'users:search'
  | 'users:create'
  | 'users:update'
  | 'users:view'
  | 'enterprises:search'
  | 'enterprises:create'
  | 'enterprises:update'
  | 'enterprises:view'
  | 'enterprises:delete'
  | 'enterprises:list'
  | 'groups:list'
  | 'groups:create'
  | 'groups:update'
  | 'groups:delete'
  | 'groups:view'
  | 'policies:list'
  | 'policies:create'
  | 'policies:update'
  | 'policies:delete'
  | 'policies:view'
  | 'menus:account'
  | 'menus:returns'
  | 'menus:suivi'
  | 'menus:orders'
  | 'menus:enterprises'
  | 'menus:organizations'
  | 'menus:dashboard'
  | 'menus:users'
  | 'menus:usersmanagement'
  | 'menus:groups'
  | 'menus:policies'
  | 'admin:maintenance:view'
  | 'admin:maintenance:update'
  | 'menus:feedbacks'
  | 'admin:feedbacks:view'
  | 'admin:feedbacks:create'
  | 'admin:feedbacks:update'
  | 'menus:return-failures'
  | 'admin:return-failures:view'
  | 'admin:return-failures:verify'
  | 'admin:return-failures:replay'
  | 'menus:reassort-lots'
  | 'admin:reassort-lots:view'
  | 'admin:reassort-lots:update';

/**
 * Legacy authorization mapping - kept for reference during migration
 * @deprecated This will be removed once migration is complete
 * The new system uses direct JWT permission checking via featureVoter
 */
export const authorizations: Record<string, string[]> = {
  USER: [
    'search:order',
    'detail:trace',
    'menus:account',
    'menus:returns',
    'menus:suivi',
    'display:selectEnterprise',
    'enterprises:list',
  ],
  MANAGER: [
    'display:createdByEmail',
    'display:createdByRole',
    'search:order',
    'tenant:enterprise',
    'traceList:clients',
    'tenant:enterprise',
    'menus:account',
    'menus:returns',
    'menus:suivi',
    'menus:orders',
    'menus:organizations',
    'display:selectEnterprise',
    'enterprises:list',
  ],
  ADMIN: [
    'display:createdByEmail',
    'display:createdByRole',
    'display:selectEnterprise',
    'tenant:enterprise',
    'traceList:admins',
    'organizations:list',
    'organizations:create',
    'organizations:update',
    'organizations:delete',
    'organizations:view',
    'users:search',
    'users:create',
    'users:update',
    'users:view',
    'enterprises:search',
    'enterprises:create',
    'enterprises:update',
    'enterprises:view',
    'enterprises:delete',
    'enterprises:list',
    'groups:list',
    'groups:create',
    'groups:update',
    'groups:delete',
    'groups:view',
    'policies:list',
    'policies:create',
    'policies:update',
    'policies:delete',
    'policies:view',
    'menus:account',
    'menus:returns',
    'menus:suivi',
    'menus:orders',
    'menus:enterprises',
    'menus:organizations',
    'menus:dashboard',
    'menus:users',
    'menus:usersmanagement',
    'menus:groups',
    'menus:policies',
    'admin:maintenance:view',
    'admin:maintenance:update',
    'menus:feedbacks',
    'admin:feedbacks:view',
    'admin:feedbacks:create',
    'admin:feedbacks:update',
    'menus:return-failures',
    'admin:return-failures:view',
    'admin:return-failures:verify',
    'admin:return-failures:replay',
    'menus:reassort-lots',
    'admin:reassort-lots:view',
    'admin:reassort-lots:update',
  ],
};

/**
 * Legacy authorize function - kept for backward compatibility during migration
 * @deprecated Use featureVoter directly with permission strings instead
 *
 * Example migration:
 * OLD: authorize(user?.group || '', 'detail:trace')
 * NEW: featureVoter('detail:trace')
 */
export const authorize = (group: string, policy: Policy) => {
  return authorizations?.[group]?.includes(policy);
};

/**
 * New permission checker using FastlessJS v0.7.2 simplified system
 * Uses direct JWT permission checking - no group mapping needed
 * @param feature - Direct permission string from JWT
 */
export const checkPermission = (feature: string) => {
  return featureVoter(feature);
};

// Re-export FastlessJS permission functions for convenience
export { featureVoter } from '@fastlessjs/backoffice-layer/dist/services';
